import React from 'react';

const SalesforceCallback = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const authCode = urlParams.get('code');
  return <div>{ authCode }</div>;
};

export default SalesforceCallback;